(function () {
  'use strict'

  require('dynamic-bind-html')
  require('./scss/app.scss')

  const MODULE_NAME = 'thismoment.card.component.appHtml'
  const templateUrl = require('./tpl/app-html.html')

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml',
      require('angular-sanitize')
    ])
    .component('thismomentAppHtml', {
      require: {
        parent: '^thismomentCard'
      },
      bindings: {
        item: '<'
      },
      templateUrl: templateUrl,
      controller: appHtmlController
    })

  appHtmlController.$inject = []
  function appHtmlController () {
    var vm = this

    vm.$onInit = appHtmlInit

    function appHtmlInit () {
      vm.trackEvent = vm.parent.trackEvent
      if (angular.isDefined(vm.item.app.user)) {
        if (angular.isDefined(vm.item.app.user.vcard) && vm.item.app.user.vcard) {
          vm.item.app.html = vm.item.app.html.replace(/__EMAIL__/g, vm.item.app.user.vcard.email)
          vm.item.app.html = vm.item.app.html.replace(/__PHONE__/g, vm.item.app.user.vcard.phone_selected)
          vm.item.app.html = vm.item.app.html.replace(/__FIRSTNAME__/g, vm.item.app.user.vcard.first_name)
          vm.item.app.html = vm.item.app.html.replace(/__LASTNAME__/g, vm.item.app.user.vcard.last_name)
          vm.item.app.html = vm.item.app.html.replace(/__PROFILEIMAGE__/g, vm.item.app.user.vcard.profile_image)
          vm.item.app.html = vm.item.app.html.replace(/__TAGLINE__/g, vm.item.app.user.vcard.tagline)
        }
        if (angular.isDefined(vm.item.app.user.ecard) && vm.item.app.user.ecard) {
          vm.item.app.html = vm.item.app.html.replace(/__TIME__/g, vm.item.app.user.ecard.time_display)
          vm.item.app.html = vm.item.app.html.replace(/__DATE__/g, vm.item.app.user.ecard.date_display)
          vm.item.app.html = vm.item.app.html.replace(/__LOCATION__/g, vm.item.app.user.ecard.location)
          vm.item.app.html = vm.item.app.html.replace(/__URL__/g, vm.item.app.user.ecard.url)
          vm.item.app.html = vm.item.app.html.replace(/__TITLE__/g, vm.item.app.user.ecard.title)
          vm.item.app.html = vm.item.app.html.replace(/__DESCRIPTION__/g, vm.item.app.user.ecard.description)
        }
        if (angular.isDefined(vm.item.app.user.ucard) && vm.item.app.user.ucard) {
          vm.item.app.html = vm.item.app.html.replace(/__USER_EMAIL__/g, vm.item.app.user.ucard.email)
          vm.item.app.html = vm.item.app.html.replace(/__USER_PHONE__/g, vm.item.app.user.ucard.phone)
          vm.item.app.html = vm.item.app.html.replace(/__USER_FIRSTNAME__/g, vm.item.app.user.ucard.first_name)
          vm.item.app.html = vm.item.app.html.replace(/__USER_LASTNAME__/g, vm.item.app.user.ucard.last_name)
        }
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/app-html.js